var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fab',{attrs:{"position":_vm.position,"bg-color":_vm.bgColor,"enable-rotation":false,"main-tooltip":_vm.tooltipMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }